import type { BundleItem } from "@p0security/shared/types/bundle";
import { Space } from "@p0security/ui";
import { FormRow } from "components/common/FormRow";
import { PillSelect } from "components/common/PillSelect";
import { useCallback } from "react";

import { BundleMemberPicker } from "./BundleMemberPicker";
import { MODE_OPTIONS, type ResourceMode } from "./ResourceEditor";

export const BundleResourceEditor: React.FC<{
  items: BundleItem[];
  onItemsChange: (items: BundleItem[]) => void;
  onPolicyRedirect: (mode: ResourceMode) => void;
}> = ({ items, onItemsChange, onPolicyRedirect }) => {
  const handleModeChange = useCallback(
    (mode: ResourceMode) => {
      if (mode !== "bundle") {
        onPolicyRedirect(mode);
      }
    },
    [onPolicyRedirect]
  );

  return (
    <Space direction="vertical" size="small" className="w-full">
      <FormRow>
        <PillSelect<ResourceMode>
          options={MODE_OPTIONS}
          value="bundle"
          onChange={handleModeChange}
          placeholder="Select what this policy applies to"
        />
      </FormRow>
      <BundleMemberPicker items={items} onChange={onItemsChange} />
    </Space>
  );
};
